export default (theme) => ({
  root: {
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      marginBottom: 0,
    },
  },
})
